<template>
  <RsPartialNavigationContainer v-if="!isReportingHidden" :key="variant" class="rs-partial-nav-reports">
    <RsPartialNavigationTree
      title="Reports"
      icon="far fa-chart-bar rs-text-tertiary-medium-purple"
      active-icon="fas fa-chart-bar rs-text-primary"
      icon-size="lg"
      class="rs-text-white"
      :variant="(variant as NavigationTreeVariantType)"
      :expanded="expanded"
      :active="routeStartsWith('/reporting') && !routeIncludes('/reporting/market-insights')"
    >
      <RsPartialNavigationTreeBranch
        v-if="$rsGlobals.$currentClient.hasRentalsBundle"
        :title="$ts('reporting.nav.listingsEngagement')"
        :to="{ name: 'ReportingListingEngagements' }"
        :active="routeEndsWith('/reporting/listings-engagement')"
      />

      <RsPartialNavigationTreeBranch
        v-if="['leads_reporting', 'websites_reporting'].some(key => $rsGlobals.$userHasAtLeastOneAccess(key))"
      >
        <RsPartialNavigationTree
          title="Leads"
          class="rs-text-white"
          :active="routeIncludes('/reporting/leads')"
          :expanded="routeIncludes('/reporting/leads')"
        >
          <RsPartialNavigationTreeBranch v-if="$rsGlobals.$userHasAtLeastOneAccess('leads_reporting')">
            <RsPartialNavigationTree
              :title="$ts('reporting.nav.leads.totalLeads.title')"
              :active="routeIncludes('/reporting/leads/total')"
              :expanded="routeIncludes('/reporting/leads/total')"
            >
              <RsPartialNavigationTreeBranch
                :title="$ts('reporting.nav.leads.totalLeads.overview')"
                :to="{ name: 'ReportingTotalLeadsOverview' }"
                :active="routeIncludes('/reporting/leads/total/overview')"
              />
              <RsPartialNavigationTreeBranch
                :title="$ts('reporting.nav.leads.totalLeads.byDay')"
                :to="{ name: 'ReportingTotalLeadsByDay' }"
                :active="routeIncludes('/reporting/leads/total/day')"
              />
              <RsPartialNavigationTreeBranch
                :title="$ts('reporting.nav.leads.totalLeads.byProperty')"
                :to="{ name: 'ReportingTotalLeadsByProperty' }"
                :active="routeIncludes('/reporting/leads/total/property')"
              />
              <RsPartialNavigationTreeBranch
                :title="$ts('reporting.nav.leads.totalLeads.byCity')"
                :to="{ name: 'ReportingTotalLeadsByCity' }"
                :active="routeIncludes('/reporting/leads/total/city')"
              />
              <RsPartialNavigationTreeBranch
                :title="$ts('reporting.nav.leads.totalLeads.bySource')"
                :to="{ name: 'ReportingTotalLeadsBySourceDay' }"
                :active="routeIncludes('/reporting/leads/total/source/')"
              />
            </RsPartialNavigationTree>
          </RsPartialNavigationTreeBranch>

          <RsPartialNavigationTreeBranch v-if="$rsGlobals.$userHasAtLeastOneAccess('leads_reporting')">
            <RsPartialNavigationTree
              :title="$ts('reporting.nav.leads.listingSiteLeads.title')"
              :active="routeIncludes('/reporting/leads/site')"
              :expanded="routeIncludes('/reporting/leads/site')"
            >
              <RsPartialNavigationTreeBranch
                :title="$ts('reporting.nav.leads.listingSiteLeads.overview')"
                :to="{ name: 'ReportingSiteLeadsOverview' }"
                :active="routeEndsWith('/reporting/leads/site/overview')"
              />
              <RsPartialNavigationTreeBranch
                :title="$ts('reporting.nav.leads.listingSiteLeads.bySource')"
                :to="{ name: 'ReportingSiteLeadsBySource' }"
                :active="routeEndsWith('/reporting/leads/site/source')"
              />
              <RsPartialNavigationTreeBranch
                :title="$ts('reporting.nav.leads.listingSiteLeads.recentTrends')"
                :to="{ name: 'ReportingSiteLeadsAdTrend' }"
                :active="routeEndsWith('/reporting/leads/site/ad-trend')"
              />
              <RsPartialNavigationTreeBranch
                v-if="$rsGlobals.$currentUser.getClientSettingValue('infinity_source_reporting') === '1'"
                :title="$ts('reporting.nav.leads.listingSiteLeads.infinity')"
                :to="{ name: 'ReportingSiteLeadsInfinity' }"
                :active="routeEndsWith('/reporting/leads/site/infinity')"
              />
            </RsPartialNavigationTree>
          </RsPartialNavigationTreeBranch>

          <RsPartialNavigationTreeBranch v-if="$rsGlobals.$userHasAtLeastOneAccess('websites_reporting')">
            <RsPartialNavigationTree
              :title="$ts('reporting.nav.leads.websiteLeads.title')"
              :active="routeIncludes('/reporting/leads/website')"
              :expanded="routeIncludes('/reporting/leads/website')"
            >
              <RsPartialNavigationTreeBranch
                :title="$ts('reporting.nav.leads.websiteLeads.overview')"
                :to="{ name: 'ReportingLeadsWebsiteOverview' }"
                :active="routeEndsWith('/reporting/leads/website/overview')"
              />
              <RsPartialNavigationTreeBranch
                :title="$ts('reporting.nav.leads.websiteLeads.referralSources')"
                :to="{ name: 'ReportingLeadsWebsiteReferral' }"
                :active="routeEndsWith('/reporting/leads/website/referral')"
              />
              <RsPartialNavigationTreeBranch
                v-if="$rsGlobals.$userHasAtLeastOneAccess('leads_reporting')"
                :title="$ts('reporting.nav.leads.websiteLeads.phoneCalls')"
                :to="{ name: 'ReportingLeadsWebsiteCallReport' }"
                :active="routeEndsWith('/reporting/leads/website/call-report')"
              />
            </RsPartialNavigationTree>
          </RsPartialNavigationTreeBranch>
        </RsPartialNavigationTree>
      </RsPartialNavigationTreeBranch>

      <RsPartialNavigationTreeBranch v-if="$rsGlobals.$userHasAtLeastOneAccess('leads_reporting')">
        <RsPartialNavigationTree
          :title="$ts('reporting.nav.callTracking.title')"
          class="rs-text-white"
          :active="routeIncludes('/reporting/call-tracking')"
          :expanded="routeIncludes('/reporting/call-tracking')"
        >
          <RsPartialNavigationTreeBranch
            :title="$ts('reporting.nav.callTracking.overview')"
            :to="{ name: 'ReportingCallTrackingOverview' }"
            :active="routeEndsWith('/reporting/call-tracking/overview')"
          />
          <RsPartialNavigationTreeBranch
            :title="$ts('reporting.nav.callTracking.callsBySource')"
            :to="{ name: 'ReportingCallTrackingCallsBySource' }"
            :active="routeEndsWith('/reporting/call-tracking/calls-by-source')"
          />
          <RsPartialNavigationTreeBranch
            :title="$ts('reporting.nav.callTracking.callsByProperty')"
            :to="{ name: 'ReportingCallTrackingCallsByProperty' }"
            :active="routeEndsWith('/reporting/call-tracking/calls-by-property')"
          />
          <RsPartialNavigationTreeBranch
            :title="$ts('reporting.nav.callTracking.callDuration')"
            :to="{ name: 'ReportingCallTrackingDuration' }"
            :active="routeIncludes('/reporting/call-tracking/duration')"
          />
          <RsPartialNavigationTreeBranch
            :title="$ts('reporting.nav.callTracking.peakUsage')"
            :to="{ name: 'ReportingCallTrackingUsage' }"
            :active="routeIncludes('/reporting/call-tracking/usage')"
          />
        </RsPartialNavigationTree>
      </RsPartialNavigationTreeBranch>

      <RsPartialNavigationTreeBranch v-if="$rsGlobals.$userHasAtLeastOneAccess('websites_reporting')">
        <RsPartialNavigationTree
          :title="$ts('reporting.nav.websites.title')"
          class="rs-text-white"
          :active="routeIncludes('/reporting/websites')"
          :expanded="routeIncludes('/reporting/websites')"
        >
          <RsPartialNavigationTreeBranch
            :title="$ts('reporting.nav.websites.overview')"
            :to="{ name: 'ReportingWebsitesLeads' }"
            :active="routeEndsWith('/reporting/websites/leads')"
          />
          <RsPartialNavigationTreeBranch
            :title="$ts('reporting.nav.websites.traffic')"
            :to="{ name: 'ReportingWebsitesTraffic' }"
            :active="routeStartsWith('/reporting/websites/traffic')"
          />
          <RsPartialNavigationTreeBranch
            :title="$ts('reporting.nav.websites.devices')"
            :to="{ name: 'ReportingLeadsWebsiteDevices' }"
            :active="routeEndsWith('/reporting/websites/devices')"
          />
          <RsPartialNavigationTreeBranch
            v-show="false"
            :title="$ts('reporting.nav.websites.events')"
            :to="{ name: 'ReportingWebsitesEvents' }"
            :active="routeEndsWith('/reporting/websites/events')"
          />
        </RsPartialNavigationTree>
      </RsPartialNavigationTreeBranch>

      <RsPartialNavigationTreeBranch
        v-if="$rsGlobals.$userHasAtLeastOneAccess('floorplan_navigator_reporting')"
        :title="$ts('reporting.nav.floorplanNavigator')"
        :to="{ name: 'ReportingFloorplanNavigator' }"
        :active="routeEndsWith('/reporting/floorplan-navigator')"
      />
      <RsPartialNavigationTreeBranch
        v-if="$rsGlobals.$userHasAtLeastOneAccess('tours_reporting')"
        :title="$ts('reporting.nav.tours')"
        :to="{ name: 'ReportingTours' }"
        :active="routeEndsWith('/reporting/tours')"
      />

      <RsPartialNavigationTreeBranch v-if="hasGoogleAds">
        <RsPartialNavigationTree
          :title="$ts('reporting.nav.digitalMarketing.title')"
          class="rs-text-white"
          :active="routeIncludes('/reporting/marketing')"
          :expanded="routeIncludes('/reporting/marketing')"
        >
          <RsPartialNavigationTreeBranch
            :title="$ts('reporting.nav.digitalMarketing.googleAds')"
            :to="{ name: 'ReportingGoogleAds' }"
            :active="routeEndsWith('/reporting/marketing/google-ads')"
          />
        </RsPartialNavigationTree>
      </RsPartialNavigationTreeBranch>

      <RsPartialNavigationTreeBranch
        v-if="$rsGlobals.$userHasAtLeastOneAccess('listing_scores_reporting')"
        :title="$ts('reporting.nav.listingScores')"
        :to="{ name: 'ReportingListingScores' }"
        :active="routeEndsWith('/reporting/listing-scores')"
      />

    </RsPartialNavigationTree>
  </RsPartialNavigationContainer>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import RsPartialNavigationContainer from '@/components/RsPartialNavigationContainer.vue';
import RsPartialNavigationTree, { NavigationTreeVariantType } from '@/components/RsPartialNavigationTree.vue';
import RsPartialNavigationTreeBranch from '@/components/RsPartialNavigationTreeBranch.vue';
import { routeEndsWith, routeIncludes, routeStartsWith } from '@/shared/helpers/navigation-active-helpers';

export default defineComponent({
  components: {
    RsPartialNavigationContainer,
    RsPartialNavigationTree,
    RsPartialNavigationTreeBranch,
  },

  props: {
    variant: {
      type: String,
      default: 'collapse',
    },
    expanded: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isTotalLeadsActive(): boolean {
      return [
        '/reporting/leads/property',
        '/reporting/leads/daily',
        '/reporting/leads/city',
        '/reporting/leads/city-breakdown',
        '/reporting/leads/source-breakdown',
      ].some((route) => routeEndsWith(route));
    },

    isWebsitesActive(): boolean {
      return [
        '/reporting/website/main',
        '/reporting/leads/website',
        '/reporting/website/traffic',
      ].some((route) => routeEndsWith(route));
    },

    isReportingHidden(): boolean {
      return (
        ![
          'leads_reporting',
          'websites_reporting',
          'tours_reporting',
          'floorplan_navigator_reporting',
        ].find((key) => this.$rsGlobals.$userHasAtLeastOneAccess(key))
        && !this.hasGoogleAds
        && !this.hasListingScores
      );
    },

    hasSyndication(): boolean {
      return this.$rsGlobals.$userHasAccess('rentsync', 'read');
    },

    hasMainReporting(): boolean {
      return this.$rsGlobals.$userHasAccess('insights', 'read');
    },

    hasWebsites(): boolean {
      return this.$rsGlobals.$userHasAccess({ key: 'sites', keyType: 'site', accessType: 'read' });
    },

    hasTourAdmin(): boolean {
      return this.$rsGlobals.$userHasAccess('tour_admins');
    },

    hasCallTracking(): boolean {
      return this.$rsGlobals.$userHasAccess('call_tracking');
    },

    hasGoogleAds(): boolean {
      return this.$rsGlobals.$currentUser.getClientSettingValue('google_ads_account_id') !== -1
        && this.$rsGlobals.$userHasAtLeastOneAccess('digital_marketing_reporting');
    },

    hasListingScores(): boolean {
      return !this.$rsGlobals.$isListingScoresDisabled
        && this.$rsGlobals.$userHasAtLeastOneAccess('listing_scores_reporting');
    },
  },

  methods: {
    routeStartsWith,
    routeEndsWith,
    routeIncludes,
  },
});
</script>

<style lang="scss">

</style>
